import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { BehaviorSubject, map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ListsService {
  hasInternetSubject = new BehaviorSubject<boolean>(true);
  consultor = new BehaviorSubject<any>(null);
  completeDeviceInfo: any = null;

  constructor(private _http: HttpClient) {}

  getNationalities() {
    return this._http
      .get(`${environment.serverUrl}/app/listNationalities/getNationalityList`)
      .pipe(
        map((response: any) => {
          return response.nationalities.map((item: any) => ({
            value: item.id,
            label: item.name,
          }));
        })
      );
  }


  getUbication(filter: string) {
    return this._http.post(
      `${environment.serverUrl}/app/listUbicacion/filterUbication`,
      { filter }
    );
  }

  getUbicationById(id: number) {
    return this._http.post(
      `${environment.serverUrl}/app/listUbicacion/filterUbicationById`,
      { id }
    );
  }

  searchEconomicActivity(term: string): Observable<any[]> {
    return this._http
      .post<any>(
        `${environment.serverUrl}/app/listEconomicActivities/search`,
        { world: term }
      )
      .pipe(
        map((response: any) => response.data ?? [])
      );
  }

  findByIdEconomicActivity(id: number): Observable<any> {
    return this._http.get<any>(
      `${environment.serverUrl}/app/listEconomicActivities/show/${id}`
    );
  }

  findByIdCodPro(id: number): Observable<any> {
    return this._http.get<any>(
      `${environment.serverUrl}/app/listCodpro/show/${id}`
    );
  }

  getCodpro() {
    return this._http.get(`${ environment.serverUrl }/app/listCodpro`).pipe(
      map((response: any) => {
        return response.list.map((item: any) => ({
          value: item.id,
          label: item.name,
        }));
      })
    );
  }

  getCompanies() {
    return this._http.get(`${ environment.serverUrl }/app/listEmpresas`).pipe(
      map((response: any) => {
        return response.list.map((item: any) => ({
          value: item.id,
          label: `${item.name} - ${item.commercialName}`,
        }));
      })
    );
  }

  getAsotip() {
    return this._http.get(`${environment.serverUrl}/app/listAsotip`).pipe(
      map((response: any) => {
        return response.list.map((item: any) => ({
          value: item.id,
          label: item.codefixed,
        }));
      })
    );
  }

  getIndAct() {
    return this._http.get(`${ environment.serverUrl }/app/listIndAct`).pipe(
      map((response: any) => {
        return response.list.map((item: any) => ({
          value: item.id,
          label: item.name,
        }));
      })
    );
  }

  getPensioner() {
    return this._http.get(`${ environment.serverUrl }/app/listPensionados`).pipe(
      map((response: any) => {
        return response.list.map((item: any) => ({
          value: item.id,
          label: item.name,
        }));
      })
    );
  }

  getSegAgr() {
    return this._http.get(`${ environment.serverUrl }/app/listSegagr/`).pipe(
      map((response: any) => {
        return response.list.map((item: any) => ({
          value: item.id,
          label: item.name,
        }));
      })
    );
  }

  getAllSpecialProgram(){
    return this._http.get(`${environment.serverUrl}/app/listSpecialProtectionProgram/getAllByOnboarding`).pipe(
      map((response: any) => {
        return response.data.map((item: any) => ({
          value: item.id,
          label: item.name,
        }));
      })
    );
  }

  getAllBanks() {
    return this._http.get(`${ environment.serverUrl }/app/debitbank/findAllEnable`).pipe(
      map((response: any) => {
        return response.data.map((item: any) => ({
          value: item.id,
          label: item.bankName,
        }));
      })
    );
  }

  getAllAcademicLevels(){
    return this._http.get(`${environment.serverUrl}/app/listAcademicLevels/getAllOnboarding`).pipe(
      map((response: any) => {
        return response.data.map((item: any) => ({
          value: item.id,
          label: item.name,
        }));
      })
    );
  }

    getTargets() {
      return this._http.get(`${ environment.serverUrl }/app/listTargetPaP/getTargetPapList`).pipe(
        map((response: any) => {
          return response.targets.map((item: any) => ({
            value: item.id,
            label: item.name,
            categoryId: item.listSavingCategoryId,
          }));
        })
      );;
    }

  getPaymentMethods(): Observable<any> {
    return this._http.get(`${ environment.serverUrl }/app/paymenthMetods/getAll`).pipe(
      map((response: any) => {
        return response.data.map((item: any) => ({
          value: item.id,
          label: item.name,
          url: item.url,
        }));
      })
    );
  }

  verifyDepartmentByCity(city: string) {
    return this._http.post(`${ environment.serverUrl }/app/listUbicacion/findDepartmentsBySimpleName`, {city});
  }

  searchCountries(searchTerm: string) {
    return this._http.post(`${ environment.serverUrl }/app/country/findAllByTerm`, {searchTerm: searchTerm});
  }

  getCountryFormats(countryId: number) {
    return this._http.get(`${ environment.serverUrl }/app/tributary/${countryId}`);
  }
}
